import type { UrlState } from '@/shared/lib/hooks';

export interface MappingUrlState extends UrlState {
  consignmentNumber: string;
  organizationId: string;
  vehicleCategories: string;
}

export const DEFAULT_MAPPING_URL_STATE: MappingUrlState = {
  consignmentNumber: '',
  organizationId: '',
  vehicleCategories: ''
};
